import * as types from './constants';

// Generate Analytics Users Report
export const generateAnalyticsUsersReportRequest = data => (
  { type: types.GENERATE_ANALYTICS_USERS_REPORT_REQUEST, payload: data }
);

export const generateAnalyticsUsersReportDone = data => (
  { type: types.GENERATE_ANALYTICS_USERS_REPORT_DONE, payload: data }
);

export const generateAnalyticsUsersReportFailed = errors => (
  { type: types.GENERATE_ANALYTICS_USERS_REPORT_FAILED, payload: errors }
);

export const generateAnalyticsUsersReportReset = () => (
  { type: types.GENERATE_ANALYTICS_USERS_REPORT_RESET }
);